import React, { useEffect, useState } from "react";
import { FaGoogle } from "react-icons/fa";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useInterval } from "usehooks-ts";
//import { useAuth } from "../../context/AuthContext";
import { useLazyQuery } from "@apollo/client";
import { Spinner } from "../../elements/Spinners";
import { LoginForm } from "./fragments/LoginForm";
import { LoginLayout } from "./LoginLayout";
import { CHECK_AUTH } from "../../queries/auth";

const GOOGLE_AUTH = import.meta.env.VITE_GOOGLE_AUTH_URL;

export const SignInUpContainer = () => {
  //    const { check } = useAuth();

  const [state, setState] = useState({
    count: 0,
    isLogging: false,
    isRegistering: false,
    isPopUpOpen: false,
    popUpProxy: undefined,
  });
  const [auth, { loading, data, error, refetch }] = useLazyQuery(CHECK_AUTH);
  const { search } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  useInterval(
    () => {
      setState({ ...state, count: state.count + 1 });
      auth().then((res) => {
        if (res.error === undefined) {
          window.location.href = searchParams.get("redirect") || "/";
        }
      });
    },
    state.isLogging ? 1000 : null,
  );

  const handleGoogleLogin = (ev: any) => {
    ev.preventDefault();
    const w = window.open(
      GOOGLE_AUTH,
      "_blank",
      "popup=true width=500 height=600",
    );
    //@ts-ignore
    setState({
      ...state,
      isLogging: true,
      count: 1,
      popUpProxy: w as any,
      isPopUpOpen: true,
    });
  };

  useInterval(
    () => {
      //@ts-ignore
      if (typeof state.popUpProxy != "undefined" && state.popUpProxy?.closed) {
        setState({
          ...state,
          isLogging: false,
          popUpProxy: undefined,
          isPopUpOpen: false,
        });
        window.location.href = searchParams.get("redirect") || "/";
      }
    },
    state.isPopUpOpen ? 1000 : null,
  );

  useEffect(() => {
    auth().then((res) => {
      if (res.error === undefined && res.data !== undefined) {
        window.location.href = searchParams.get("redirect") || "/";
      }
    });
  }, [state.isPopUpOpen]);

  return (
    <LoginLayout>
      <div className="py-8 w-full">
        <p className="text-base font-light mb-6 sm:mb-12">
          AgBase offers the most comprehensive directory of agtech and foodtech
          companies, funders, and trends across emerging markets in Africa,
          Latin America and Asia Pacific. <br /> Access tailored insights to
          drive innovation in agriculture.
        </p>
        <p className="text-2xl font-bold">Sign In</p>
        <div className="flex flex-col gap-4 my-4 sm:mb-6">
          <p className="text-[#ABABAB]">
            Don't have an account?{" "}
            <Link
              to={`/sign-up${search}`}
              className="text-[#015659] font-semibold"
            >
              Sign up
            </Link>
          </p>
        </div>
        {state.isLogging && <Spinner message={`Logging in...`} />}
        {!state.isRegistering && (
          <>
            <LoginForm
              onSuccess={() => {
                setState({ ...state, isLogging: true });
              }}
            />
          </>
        )}
        <div className="w-full h-[19px] flex justify-between items-center mt-4">
          <div className="w-full h-px bg-[#ebeaed]" />
          <div className="px-3 text-sm font-semibold text-left text-[#ABABAB]">
            or
          </div>
          <div className="w-full h-px bg-[#ebeaed]" />
        </div>
        <div className="flex flex-col gap-4 mt-6">
          <Link
            className="border rounded-lg flex items-center justify-center gap-4 font-semibold py-2 border-black"
            to={`${GOOGLE_AUTH}?mode=redirect&return_url=${window.location.origin}`}
          >
            <FaGoogle /> Sign in with Google
          </Link>
        </div>
        <p className="mt-6 text-center text-[#ABABAB]">
          Protected by reCAPTCHA and subject to the Google <br />
          <Link target="_blank" to="/privacy-policy">
            <span className="text-[#015659] font-semibold mx-1">
              Privacy Policy
            </span>
          </Link>
          and
          <Link target="_blank" to="/terms-of-use">
            <span className="text-[#015659] font-semibold mx-1">
              Terms of Service.
            </span>
          </Link>
        </p>
      </div>
    </LoginLayout>
  );
};
